export * from './lib/interfaces/select-form-field-config.interface';

export * from './lib/form-select.module';
